import React, {useState, useCallback} from 'react';
import styled from 'styled-components';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from 'components/CTA/SGButton';
import Paper from 'components/Paper';
import {Grid} from '@material-ui/core';
import SGTitle from './Typography/SGTitle';
import SGBody from './Typography/SGBody';

const StyledPaper = styled(Paper)`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  gap: 16px;
`;

interface DebugJsonTextAreaProps {
  ariaLabel: string;
  handleUpdateJson: (jsonString: string) => void;
  handleUseNonDebug: () => void;
}

function DebugJsonTextArea({
  ariaLabel,
  handleUpdateJson,
  handleUseNonDebug,
}: DebugJsonTextAreaProps) {
  const [jsonString, setJsonString] = useState<string | null>(null);
  const [isValidJson, setIsValidJson] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleUpdateText = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    try {
      JSON.parse(event.target.value);
      setIsValidJson(true);
      setErrorMessage(null);
    } catch (e) {
      setIsValidJson(false);
      setErrorMessage('Invalid JSON format');
    }
    setJsonString(event.target.value);
  };

  const handleSubmit = useCallback(() => {
    if (!isValidJson || jsonString === null) {
      return;
    }
    handleUpdateJson(jsonString);
  }, [isValidJson, jsonString]);

  const handleReset = () => {
    handleUseNonDebug();
    setJsonString(null);
  };

  return (
    <StyledPaper>
      <form method="post">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SGTitle>Debug Section - Insert custom JSON</SGTitle>
          </Grid>
          <Grid item xs={12}>
            <StyledButtonContainer>
              <Button onClick={handleReset} variant="outlined">
                Clear
              </Button>
              <Button onClick={handleSubmit} disabled={!isValidJson}>
                Submit
              </Button>
            </StyledButtonContainer>
          </Grid>
          {errorMessage && (
            <Grid item xs={12}>
              <SGBody>{errorMessage}</SGBody>
            </Grid>
          )}
          <Grid item xs={12}>
            <TextareaAutosize
              name="postContent"
              aria-label={ariaLabel}
              rowsMax={10}
              cols={40}
              value={jsonString || ''}
              onChange={handleUpdateText}
            />
          </Grid>
        </Grid>
      </form>
    </StyledPaper>
  );
}

export default DebugJsonTextArea;
